var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-simple-upload',{staticClass:"site-logo-upload",attrs:{"show-upload-button":false,"text":_vm.text},on:{"change":_vm.changePdf}})}
var staticRenderFns = []

export { render, staticRenderFns }